export const formatClassificationCode = (classificationCode?: string): string => {
  if (!classificationCode) return ''

  let formattedCode = classificationCode
  if (formattedCode.length > 4) {
    formattedCode = formattedCode.substring(0, 4) + ' ' + formattedCode.substring(4)
  }
  if (formattedCode.length > 7) {
    formattedCode = formattedCode.substring(0, 7) + ' ' + formattedCode.substring(7)
  }

  return formattedCode
}

export const removeSubHeading = (localTariff: string, hsSubheading: string): string => {
  if (localTariff.substring(0, hsSubheading.length) === hsSubheading) {
    return localTariff.substring(hsSubheading.length, localTariff.length)
  }
  return localTariff
}

export const addSubHeading = (localTariff: string, hsSubheading: string): string => {
  if (!localTariff || localTariff.substring(0, hsSubheading.length) === hsSubheading) {
    return hsSubheading + (localTariff ?? '')
  }
  return hsSubheading + localTariff
}

export const isValidClassificationCodeInput = (value: string, maxLength = 6): boolean => {
  if (value.length > maxLength) return false
  if (isNaN(Number(value)) || value.indexOf('.') > -1) return false
  return true
}

export const formatHsSubheadingDisplay = (code: string, description: string): string => {
  const modifiedCode = `${code.slice(0, -2)} ${code.slice(-2)} - ${description}`
  return modifiedCode
}

export const formatHsHeadingDisplay = (code: string, description: string): string => {
  return `${code} - ${description}`
}
